module.exports = __webpack_public_path__ + "static/assets/7e5b5ac257e50986580bc8b19a844476.jpg";